module.exports = __webpack_public_path__ + "static/img/nonghuazhan.c322596c.png";